import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as Icon from "@fortawesome/free-regular-svg-icons";
import DatePicker from 'react-multi-date-picker';
import { useWorklog } from '../../Hooks/Features/ProjectGlance/useWorklog';
import { Dialog } from 'primereact/dialog';
import WorklogDetails from './WorklogDetails';
import { SkeletonContainer } from '../../components/Loader/Loader';

const Worklog = ({ projectId }) => {

    const key = "summary";
    const showPopup = {};
    const dateFilter = null;
    const { summaryData, filterValues, setFilterValues, getWorklogSummary, getIcon, showDetails, setShowDetails, loader } = useWorklog({ projectId, key, showPopup, dateFilter });

    return (
        <div className='h-100'>
            <div className="d-flex align-items-center justify-content-between p-1 pb-2">
                <div className="fs-6 fw-semibold d-flex gap-2 align-items-center">
                    <FontAwesomeIcon icon={Icon?.faClock} />
                    Worklog
                </div>
                <div className="d-flex gap-2">
                    <DatePicker placeholder='Select Date Range' range rangeHover value={filterValues?.date} onChange={(e) => setFilterValues((prev) => ({ ...prev, date: e, is_change: true }))} onClose={() => { if (filterValues?.is_change) { getWorklogSummary() } }} />
                    <div className='border rounded-pill px-3 d-flex justify-content-center align-items-center fw-semibold'  >{summaryData?.total_hours}h</div>
                </div>
            </div>
            {loader?.summary ? <div style={{ height: "100px" }}><SkeletonContainer /></div> :
                <div className='d-flex justify-content-between align-items-center flex-wrap gap-2 px-2'>
                    {summaryData?.data?.map((item) => {
                        const iconInfo = getIcon(item?.issue_type_group_key);
                        return (
                            <div key={item?.issue_type_group_id} className='d-flex justify-content-between align-items-center' style={{ width: "49%" }}>
                                <div className='d-flex gap-2 align-items-center'>
                                    <FontAwesomeIcon icon={iconInfo?.icon} style={{ color: iconInfo?.color || "black" }} />
                                    <div>{item?.issue_type_group_name}</div>
                                </div>
                                <div className='d-flex gap-2 w30 justify-content-end fw-semibold'>
                                    <div className='text-center border rounded-pill px-2 w50'>{item?.log_hours_percentage ? parseFloat(item?.log_hours_percentage?.toFixed(2)) : 0}%</div>
                                    <div className='w50 text-right c-pointer text-decoration-underline' onClick={() => setShowDetails((prev) => ({ ...prev, visible: true, group: item }))}>{item?.time_spent ? item?.time_spent : "0h"}</div>
                                </div>
                            </div>
                        )
                    })}
                </div>}

            {showDetails?.visible && <WorklogDetails projectId={projectId} showPopup={showDetails} dateFilter={filterValues?.date} onClose={() => setShowDetails((prev) => ({ ...prev, visible: false, group: {}, issue_type_data: [] }))} />}
        </div>
    )
}

export default Worklog